(function($) {
  document.addEventListener('DOMContentLoaded', (domE) => {
    // Add a simple classname to the paragraph f the IG juicer text paragraph
    const instagramFeeds = document.querySelectorAll('iframe.instagram-frame--juicer');
    for (let i = 0; i < instagramFeeds.length; i++) {
      $(instagramFeeds[i]).closest('.paragraph--type--text').addClass('instagram-feed--juicer');
    }
  });
}(jQuery));

